import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'semantic-ui-react'
import Layout from '~/components/Layout'
import TableComponent from '~/components/TableComponent'
import { MilkMoneyQuery } from '~/QueryHooks/MilkMoneyQuery'
import { Nullable } from '~/types'

type DataFilterType = {
  rows: number,
  page: number,
  month: string
}

const MilkQuality:React.FC = () => {
  const { t } = useTranslation()
  const tableColumnHeaders = [
    {
      name: t('Sampling time'),
      key: 'samplingDate',
      type: 'date',
      format: 'DD.MM.YYYY HH:mm'
    },
    {
      name: t('Fat (in %)'),
      key: 'fat',
      type: 'no-unit-number'
    },
    {
      name: t('Protein (in %)'),
      key: 'protein',
      type: 'no-unit-number'
    },
    {
      name: t('Germ count (1000/ml)'),
      key: 'germCount',
      type: 'no-unit-number',
      decimalScale: 0
    },
    {
      name: t('Cell count (1000/ml)'),
      key: 'cellCount',
      type: 'no-unit-number',
      decimalScale: 0
    },
    {
      name: t('Inhibitor'),
      key: 'inhibitorLabel'
    },
    {
      name: t('Urea (mg/dl)'),
      key: 'urea',
      type: 'no-unit-number-no-value'
    },
    {
      name: t('Lactose (in %)'),
      key: 'lactose',
      type: 'no-unit-number',
      decimalScale: 0
    },
    {
      name: t('Freezing point (in °C)'),
      key: 'freezingPoint',
      type: 'no-unit-number-no-value'
    }
  ]
  const [dataFiltered, setDataFiltered] = useState<Nullable<DataFilterType>>(null)

  const {
    data: options,
    isLoading: isLoadingOptions
  } = MilkMoneyQuery.getFarmQualityData()

  const {
    data: milkQualityList,
    isLoading: isLoadingList,
    isFetching: isFetchingList,
    refetch: fetchData
  } = MilkMoneyQuery.getFarmQualityList(dataFiltered && {
    ...dataFiltered,
    page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
  })

  useEffect(() => {
    if(!dataFiltered && options) {
      setDataFiltered({
        rows: 20,
        page: 0,
        month: options.months[0].key
      })
    }
  }, [options, dataFiltered])

  useEffect(() => {
    if(dataFiltered) {
      fetchData()
    }
  }, [dataFiltered])

  function renderTable() {
    return <TableComponent
      rows={rows}
      total={filtered}
      tableColumnHeaders={tableColumnHeaders}
      isFetchingData={isFetchingList}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
      animated
    />
  }

  function renderFilters() {
    return <>
      <Dropdown
        selectOnBlur={false}
        placeholder={t('Select date')}
        selection
        options={options?.months?.map(month => ({ text: month.label, value: month.key })) || []}
        value={dataFiltered?.month}
        onChange={(_, { value }) => {
          setDataFiltered({
            ...dataFiltered,
            month: value as string
          })
        }}
      />
    </>
  }

  const { filtered, rows } = milkQualityList ? milkQualityList : { filtered: 0, rows: [] };
  const isLoading = isLoadingList || isLoadingOptions

  return <Layout
    title={t('Milk quality')}
    segmented
    isBusy={isLoading}
    filters={renderFilters()}
  >
    {dataFiltered && milkQualityList && renderTable()}
  </Layout>
}
export default MilkQuality